import { cn } from "@/common/helpers/utils";
import { EmptyValue } from "@/components/ui/empty-value";
import type { ReactNode } from "react";

interface AddressLike {
  street?: string | null;
  houseNumber?: string | null;
  houseExtension?: string | null;
  postalCode?: string | null;
  city?: string | null;
}

interface AddressLinesProps {
  address?: AddressLike | null;
  className?: string;
  fallback?: ReactNode;
}

/**
 * Shared address renderer: street line on top, a de-emphasized city line below.
 * Empty parts are filtered out so missing fields never render stray spaces.
 */
export function AddressLines({ address, className, fallback }: AddressLinesProps) {
  const streetLine = [address?.street, address?.houseNumber, address?.houseExtension].filter(Boolean).join(" ").trim();
  const cityLine = [address?.postalCode, address?.city].filter(Boolean).join(" ").trim();

  if (!streetLine && !cityLine) {
    return fallback ?? <EmptyValue />;
  }

  return (
    <div className={cn("flex flex-col gap-0.5 text-left", className)}>
      {streetLine && <div>{streetLine}</div>}
      {cityLine && <div className="text-muted-foreground text-xs">{cityLine}</div>}
    </div>
  );
}
